import { CardAttachLocation } from "../../constants/card-constants";
import { GameProperties } from "../GameModule";

export const properties: GameProperties = {
  heroImageUrl:
    "https://cf.geekdo-images.com/ZrRidumkzu62HuwKdgQpHA__imagepage/img/rEh0oKbvD45eDIZqPZOfx0UmfhA=/fit-in/900x600/filters:no_upscale():strip_icc()/pic1430769.jpg",
  deckSite: "",
  decklistApi: "",
  decklistSearchApi: "",
  allowSpecificCardSearch: true,
  decklistSearchApiConstants: "",
  encounterUiName: "Card Sets",
  initialPlaymatImageLocation:
    "/images/from_modules/marvel-legendary/marvel_legendary_playmat1.webp",
  customPlaymatWidth: 1440,
  possibleIcons: [],
  modifiers: [],
  tokens: {
    stunned: null,
    confused: null,
    tough: null,
  },
  counterTokens: [],
  iconCounters: [],
  useAltCardArtByDefault: true,
  defaultAttachLocation: CardAttachLocation.UpAndRight,
  tableCardSlots: [
    { landscape: false, relativeX: 143, relativeY: 205 },
    { landscape: false, relativeX: 315, relativeY: 205 },
    { landscape: false, relativeX: 492, relativeY: 205 },
    { landscape: false, relativeX: 1220, relativeY: 202 },
    { landscape: false, relativeX: 1399, relativeY: 201 },
    { landscape: false, relativeX: 143, relativeY: 485 },
    { landscape: false, relativeX: 315, relativeY: 485 },
    { landscape: false, relativeX: 1399, relativeY: 481 },
    { landscape: false, relativeX: 143, relativeY: 766 },
    { landscape: false, relativeX: 315, relativeY: 766 },
    { landscape: false, relativeX: 1399, relativeY: 762 },
    { landscape: false, relativeX: 1214, relativeY: 476 },
    { landscape: false, relativeX: 1033, relativeY: 476 },
    { landscape: false, relativeX: 858, relativeY: 476 },
    { landscape: false, relativeX: 681, relativeY: 476 },
    { landscape: false, relativeX: 502, relativeY: 476 },
    { landscape: false, relativeX: 1214, relativeY: 757 },
    { landscape: false, relativeX: 1033, relativeY: 757 },
    { landscape: false, relativeX: 858, relativeY: 757 },
    { landscape: false, relativeX: 681, relativeY: 757 },
    { landscape: false, relativeX: 502, relativeY: 757 },
  ],
};
